import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";
import AddButtonWithArrow from "./AddButtonWithArrow";
import AddTraspButton from "./AddTraspButton";
import { useError } from "../../../utils/context/ErrorContext";
const FormFooter = ({
  buttonname,
  setNextvalue,
  nextvalue,
  handleSubmit,
  propertyValue,
  navigateto,
  showCancelButton,
  handleCancel,
  handleFinish
}) => {
  const navigate = useNavigate();
  
  const {setErrors, setErrorMessages} = useError();

  const handleNextQuestion = (bname) => {
    if (bname === "Next" && propertyValue?.propertyTypeId) {
      setNextvalue(true);
    }
    else {
      setErrors((prevErrors) => ({ ...prevErrors, property: true }));
      setErrorMessages((prevMessages) => ({
        ...prevMessages,
        property: "Selecting a property type is required.",
      }));
    }

    if (bname === "Create Property" || bname === "Add unit") {
      if (bname === "Create Property") {
        handleSubmit();
      } else if (bname === "Add unit") {
        navigate(navigateto);
      }
    }
  };

  const handlePrevQuestion = () => {
    setNextvalue(false);
  };

  return (
    <div className="footerSection">
      <div className="footermain d-flex justify-content-between">
        <div style={{ width: "127px" }}>
          {showCancelButton && (
            <div className="cancelButton sub_text  fw-600 " onClick={handleCancel}>
              Cancel
            </div>
          )}
        </div>
        <div className="d-flex gap-4 align-items-center">
          {nextvalue && propertyValue?.propertyTypeId &&
            <AddTraspButton
              bname="Cancel"
              onClick={handlePrevQuestion}
              width="fit-content"
            />
          }
          {!nextvalue &&
            <AddTraspButton
              bname="Cancel"
              onClick={() => navigate(-1)}
              width="fit-content"
              textclass="sub_text fw-600 blue clickable"
            />
          }
          <AddButtonWithArrow
            buttonname={buttonname}
            onClick={() => {
              if (buttonname === "Finish") {
                handleFinish();
              } else {
                handleNextQuestion(buttonname);
              }
            }}
            minWidth={buttonname === "Next" ? "100px" : ""}
          />
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
